// extracted by mini-css-extract-plugin
export default {"container":"O0-z","list":"P0-z"};